import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
function ProtectedRoute({ children }) {

  const navigate = useNavigate();
  const { user } = UserAuth();
  useEffect(()=>{

    if (!user?.accessToken) {
      return navigate("/");
    }
  })
  
  return children;
}

export default ProtectedRoute;
